import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthSessionService } from './auth-session.service';

/**
 * Blocks every route except change-password while a mandatory password change is pending.
 * Applied to public / unguarded routes; PermissionGuard and GuestGuard enforce the same rule.
 */
@Injectable({ providedIn: 'root' })
export class ForcedPasswordChangeGuard  {
  constructor(
    private authSession: AuthSessionService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree | Promise<boolean | UrlTree> {
    if (!this.authSession.isForcedPasswordChange()) {
      return true;
    }

    return this.authSession.validateForcedPasswordChangeSession().then((isValid) =>
      isValid
        ? this.router.createUrlTree(['/change-password'], {
            queryParams: this.authSession.forcedPasswordChangeQueryParams(),
          })
        : this.router.createUrlTree(['/login']),
    );
  }
}
